import { Link } from "@tanstack/react-router";
import { useState } from "react";

import { useWallet } from "../../hooks/use-wallet";
import { cn } from "../../lib/cn";
import { Button } from "../ui/Button";
import { ConnectButton } from "../wallet/ConnectButton";
import { MobileDrawer } from "./MobileDrawer";

const NAV_LINKS = [
	{ to: "/discover" as const, label: "Discover" },
	{ to: "/launch" as const, label: "Launch" },
	{ to: "/trending" as const, label: "Trending" },
	{ to: "/leaderboards" as const, label: "Leaderboards" },
];

const AUTH_NAV_LINKS = [{ to: "/dashboard" as const, label: "Dashboard" }];

export function Navbar() {
	const [isDrawerOpen, setIsDrawerOpen] = useState(false);
	const { isConnected } = useWallet();

	const allLinks = isConnected ? [...NAV_LINKS, ...AUTH_NAV_LINKS] : NAV_LINKS;

	return (
		<>
			<nav className="glass-nav sticky top-0 z-50 border-b border-pastel-border/50">
				<div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
					<div className="flex h-16 items-center justify-between">
						{/* Logo */}
						<Link to="/" className="flex items-center gap-2 text-lg font-bold text-pastel-black">
							<span className="text-xl">&#10024;</span>
							<span>0G Vibe</span>
						</Link>

						{/* Desktop Navigation */}
						<div className="hidden md:flex md:items-center md:gap-1">
							{allLinks.map((link) => (
								<Link
									key={link.label}
									to={link.to}
									className={cn(
										"px-3 py-2 rounded-lg text-sm font-medium text-pastel-gray transition-colors",
										"hover:text-pastel-black hover:bg-pastel-light-gray"
									)}
								>
									{link.label}
								</Link>
							))}
						</div>

						{/* Desktop Actions */}
						<div className="hidden md:flex md:items-center md:gap-3">
							<ConnectButton />
							<Link to="/launch">
								<Button variant="gradient" size="sm">
									Launch Token
								</Button>
							</Link>
						</div>

						{/* Mobile Hamburger */}
						<button
							type="button"
							className="inline-flex items-center justify-center rounded-lg p-2 text-pastel-gray hover:bg-pastel-light-gray hover:text-pastel-black md:hidden"
							style={{ minWidth: 44, minHeight: 44 }}
							onClick={() => setIsDrawerOpen(true)}
							aria-label="Open navigation menu"
						>
							<svg
								width="24"
								height="24"
								viewBox="0 0 24 24"
								fill="none"
								stroke="currentColor"
								strokeWidth="2"
								strokeLinecap="round"
								strokeLinejoin="round"
								aria-hidden="true"
							>
								<title>Menu</title>
								<line x1="3" y1="6" x2="21" y2="6" />
								<line x1="3" y1="12" x2="21" y2="12" />
								<line x1="3" y1="18" x2="21" y2="18" />
							</svg>
						</button>
					</div>
				</div>
			</nav>

			{/* Mobile Drawer */}
			<MobileDrawer isOpen={isDrawerOpen} onClose={() => setIsDrawerOpen(false)} links={allLinks} />
		</>
	);
}
